import * as couponCodeAction from "./couponCodeAction";

export const couponCodeFeatureKey = "couponCodeInfo";

const initialState = {
  loading: false,
  errorMsg: "",
  couponCodes: [],
  couponCodeDetails: {},
  isCouponCodeUpdated: false,
};

export const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case couponCodeAction.GET_COUPON_CODE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case couponCodeAction.GET_COUPON_CODE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        couponCodes: payload.data,
      };
    case couponCodeAction.GET_COUPON_CODE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        errorMsg: payload,
        couponCodes: [],
      };
    case couponCodeAction.GET_COUPON_CODE_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case couponCodeAction.GET_COUPON_CODE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        couponCodeDetails: payload.data,
      };
    case couponCodeAction.GET_COUPON_CODE_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        errorMsg: payload,
      };
    case couponCodeAction.CREATE_COUPON_CODE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case couponCodeAction.CREATE_COUPON_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
        isCouponCodeUpdated: true,
      };
    case couponCodeAction.CREATE_COUPON_CODE_FAILURE:
      return {
        ...state,
        loading: false,
        errorMsg: payload,
      };
    case couponCodeAction.UPDATE_COUPON_CODE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case couponCodeAction.UPDATE_COUPON_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
        isCouponCodeUpdated: true,
      };
    case couponCodeAction.UPDATE_COUPON_CODE_FAILURE:
      return {
        ...state,
        loading: false,
        errorMsg: payload,
      };
    case couponCodeAction.DELETE_COUPON_CODE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case couponCodeAction.DELETE_COUPON_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
        isCouponCodeUpdated: true,
      };
    case couponCodeAction.DELETE_COUPON_CODE_FAILURE:
      return {
        ...state,
        loading: false,
        errorMsg: payload,
      };
    case "IS_COUPON_CODE_UPDATED":
      return {
        ...state,
        isCouponCodeUpdated: false,
      };
    default:
      return state;
  }
};
